<template>
  <router-view/>
</template>

<script setup>
  import { onMounted } from 'vue'
  onMounted(async () => {
    // 添加 Brython 控制输入控件
    // const input = document.createElement("textarea")
    // input.id = "python-code"
    // input.style.display = "none"
    // document.body.appendChild(input)

    // const btn = document.createElement("button")
    // btn.id = "run-button"
    // btn.style.display = "none"
    // document.body.appendChild(btn)
  })
</script>

<style>
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
  }
</style>
